import api from "./Api";

class ExtratoNovaService {
    async cadastrarAnexo(esteiraID: number, tipo: number, bancoSelecionado: number, tipoArquivo: number, conta: string, nome: string, url: string): Promise<any> {
        const { data: result } = await api.post<any>('Extrato', {
            esteiraID,
            conta,
            path: nome,
            url,
            tipo,
            tipoArquivo,
            bancoSelecionado
        });

        return result;
    }

    async removerAnexo(id: number): Promise<void> {
        await api.delete(`Extrato/${id}`);
    }

    async removerVinculoExtrato(id: number, key: string): Promise<void> {
        await api.delete(`Extrato/DesvincularInformacao/${id}/${key}`);
    }

    async processar(id: number, conta: string): Promise<void> {
        await api.post(`Extrato/Processar/${id}/${conta}`, null);
    }

    async arquivosAnexados(esteiraID: number, conta: string): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`Extrato/${esteiraID}/${conta}`);
        return result;
    }
}


export default new ExtratoNovaService();